import mrRequest from '@/utils/request'

/* 获取商品统计数据 */
export function getGoodsAmountList() {
  return mrRequest.get({
    url: '/goods/amount/list'
  })
}

/* 获取商品分类个数 */
export function getGoodsCategoryCount() {
  return mrRequest.get({
    url: '/goods/category/count'
  })
}

/* 获取商品分类销量 */
export function getGoodsCategorySale() {
  return mrRequest.get({
    url: '/goods/category/sale'
  })
}

/* 获取商品分类收藏 */
export function getGoodsCategoryFavor() {
  return mrRequest.get({
    url: '/goods/category/favor'
  })
}

/* 获取城市销量 */
export function getGoodsAddressSale() {
  return mrRequest.get({
    url: '/goods/address/sale'
  })
}
